module.exports = __webpack_public_path__ + "img/Bahn_Schneeschleuder_1kl.6eb0740e.jpg";